export default __webpack_public_path__ + "static/media/04_photo.56165032.jpg";